// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2xgeN","containerItemsCenter":"Skeleton_containerItemsCenter__3p07A"};